export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const passwordRegex =
  /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
